import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';

import styles from './styles';

const RemovableFiltersTags = ({ classes, data, onClickHandler }) => {
  if (isEmpty(data)) return null;

  const handleRemove = item => {
    if (item !== null) {
      onClickHandler(
        data.key,
        data.value.filter(val => val !== item),
      );
    } else {
      onClickHandler(data.key, null);
    }
  };

  return isArray(data?.value) ? (
    <MultipleRemovableFilter {...{ data, classes, handleRemove }} />
  ) : (
    <SingleRemovableFilter {...{ data, classes, handleRemove }} />
  );
};

const SingleRemovableFilter = ({ data, classes, handleRemove }) => {
  return (
    <Tooltip title={data?.name} placement='top'>
      <div className={classes.removeFilterContainer}>
        <Typography className={classes.removeFilterLabel}>{data?.label}</Typography>
        <Button disableRipple className={classes.removeFilterBtn} onClick={() => handleRemove(null)}>
          <ADGMImage name='close.svg' alt='remove' />
        </Button>
      </div>
    </Tooltip>
  );
};

const MultipleRemovableFilter = ({ data, classes, handleRemove }) => {
  const [optionsOpened, setOptionsOpened] = useState(false);
  const ref = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        (!iconRef?.current || !iconRef?.current?.contains(event.target))
      ) {
        setOptionsOpened(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <div className={classes.MultipleParent}>
      <Tooltip title={data?.name} placement='top'>
        <div className={classes.removeFilterContainer}>
          <Typography className={classes.removeFilterLabel}>{`${data?.name} (${data?.value?.length})`}</Typography>
          <Button
            disableRipple
            ref={iconRef}
            className={classes.iconClickableBtn}
            onClick={() => setOptionsOpened(!optionsOpened)}
          >
            <ADGMImage
              name={optionsOpened ? 'arrow-up-black.svg' : 'arrow-down-black.svg'}
              alt='arrow'
              className={classes.iconClickable}
            />
          </Button>
        </div>
      </Tooltip>

      {optionsOpened && (
        <div className={classes.MultiFilterContainer} ref={ref}>
          <div className={classes.multiContainerHeader}>
            <Typography className={classes.removeFilterDropDownLabel}>{data?.name}</Typography>
            <Typography className={classes.clearAllBtn} onClick={() => handleRemove(null)}>
              {keyEmptyCheck('reset_filters')}
            </Typography>
          </div>

          {data?.value?.map((item, index) => (
            <div key={item} className={classes.removeFilterDropDownItem}>
              <Typography className={classes.removeFilterLabel}>{data?.label[index]}</Typography>
              <Button disableRipple className={classes.removeFilterBtn} onClick={() => handleRemove(item)}>
                <ADGMImage name='close.svg' alt='remove' className={classes.iconClickable} />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

RemovableFiltersTags.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

SingleRemovableFilter.propTypes = RemovableFiltersTags.propTypes;

MultipleRemovableFilter.propTypes = RemovableFiltersTags.propTypes;

export default withStyles(styles)(RemovableFiltersTags);
